import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-demande-service-voice-card",
  templateUrl: "./demande-service-voice-card.component.html",
  styleUrls: ["./demande-service-voice-card.component.scss"],
})
export class DemandeServiceVoiceCardComponent {
  @Input() isPlaying = false;
  @Input() isRecording = false;
  @Input() end = false;
  @Input() inPause = false;
  @Input() recordingProgressPercent = 0;
  @Input() playbackProgressPercent = 0;
  @Input() recordingClock = "0:00";
  @Input() playbackClock = "0:00 / 0:00";

  @Output() toggle = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
}
